import Tooltip from '@mui/material/Tooltip';
import type { ReactNode } from 'react';
import { Link as RouterLink, useLocation } from 'react-router';

import { SideBarItemButton } from '../side-bar-item-button/SideBarItemButton';

type SideBarNavItemProps = {
    itemKey: string;
    label: string;
    path: string;
    icon: ReactNode;
    expanded: boolean;
};

export const SideBarNavItem = ({ itemKey, label, path, icon, expanded }: SideBarNavItemProps) => {
    const location = useLocation();
    const selected =
        path === '/'
            ? location.pathname === '/'
            : location.pathname === path || location.pathname.startsWith(`${path}/`);

    const button = (
        <SideBarItemButton
            component={RouterLink}
            to={path}
            selected={selected}
            icon={icon}
            label={label}
            expanded={expanded}
            automation-id={`side-bar-nav-${itemKey}`}
            aria-label={expanded ? undefined : label}
        />
    );

    return expanded ? (
        button
    ) : (
        <Tooltip title={label} placement="right">
            {button}
        </Tooltip>
    );
};
